<div class="module-name-card__data">

  <div class="module-name-card__data__card">
    <div class="module-name-card__data__icon"><i class="lx-icon {{ module?.icon }}"></i></div>
    <div class="module-name-card__data__name">
      <p>{{ module?.name }}</p>
      <div class="module-name-card__data__description">
        {{ module?.description }}
      </div>
    </div>
  </div>

  <div class="module-name-card__data__buttons">
    <button *ngIf="editable" class="lx-btn-small lx-btn-negative"
            (click)="editModule()">Edit Module</button>
  </div>
</div>
